import { PureComponent } from 'preact-compat'
import Report, { ReportedContent } from './Report'
import Button from '@insided/control/uikit/Button'

export interface ReportsProps {
  reportedContent: ReportedContent[]
}

export interface ReportsState {
  isCollapsed: boolean
}

const DEFAULT_VISIBLE_REPORT_COUNT = 3

function isCollapsible (reportedContent: ReportedContent[]) {
  return reportedContent.length > DEFAULT_VISIBLE_REPORT_COUNT
}

export function getVisibleReports (reportedContent: ReportedContent[], isCollapsed: boolean) {
  if (isCollapsible(reportedContent) && isCollapsed) {
    return reportedContent.slice(0, DEFAULT_VISIBLE_REPORT_COUNT)
  }
  return reportedContent
}

class Reports extends PureComponent<ReportsProps, ReportsState> {
  constructor (props: ReportsProps) {
    super(props)
    this.state = {
      isCollapsed: true
    }
    this.toggleIsCollapsed = this.toggleIsCollapsed.bind(this)
  }

  toggleIsCollapsed () {
    this.setState(({ isCollapsed }) => ({ isCollapsed: !isCollapsed }))
  }

  render () {
    const { reportedContent } = this.props
    const { isCollapsed } = this.state
    const filteredReports = getVisibleReports([...reportedContent], isCollapsed)

    return (
      <div className='reported-content'>
        <div className='reported-content__count'>Reports ({reportedContent.length})</div>
        {filteredReports.map((report) => <Report {...report} key={report.id} />)}
        {
          isCollapsible(reportedContent) &&
            <Button variant='text' onClick={this.toggleIsCollapsed} endIcon={isCollapsed ? 'chevronDown' : 'chevronUp'}>
              {isCollapsed ? 'Show all reports' : 'Collapse reports'}
            </Button>
        }
      </div>
    )
  }
}

export default Reports
